export default __webpack_public_path__ + "static/media/hau.6a4227cd.png";